const Button: React.FC<
  JSX.IntrinsicElements['div'] & { disabled?: boolean }
> = ({
  children,
  disabled = false,
  className = '',
  ...props
}) => (
  <div
    className={`flex h-8 cursor-pointer select-none items-center justify-center gap-2 whitespace-nowrap rounded-md text-sm opacity-100 transition ease-in-out hover:translate-y-1 hover:opacity-80 ${
      disabled && 'pointer-events-none opacity-50'
    } ${children ? 'px-1' : 'w-8'} ${className}`}
    {...props}
  >
    {children}
  </div>
)
export default Button
